import {Component, OnInit} from '@angular/core';
import {Dealer} from 'src/app/models/dealers/dealer.model';
import {HttpService} from 'src/app/services/http.service';
import {DealerList} from '../../../models/dealers/dealer-list.model';
import {DealerFilter} from '../../../models/dealers/dealer-filter.model';
import {SweetUtil} from '../../commons/sweet/sweet-util-service';
import {FeatureToggleService} from '../../../toggle/feature-toggle.service';
import {FeatureToggle} from '../../../toggle/feature-toggle';
import {ContractType} from '../../../models/warranties/contract-type.model';
import {Market} from '../../../models/dealers/market.enum';
import {AuthService} from '../../../auth/auth.service';
import {DealerProduct} from '../../../models/dealers/dealer-product.model';
import isNumber from 'is-number';
import {DealerService} from '../../dealer/dealer.service';

@Component({
  selector: 'app-dealer-list',
  templateUrl: './dealer-list.component.html',
  styleUrls: ['./dealer-list.component.scss']
})
export class DealerListComponent implements OnInit {
  market: Market;
  regions: Array<string>;
  dealers: Dealer[] = [];
  displayContractTypes: string[] = [];
  contractTypes: ContractType[] = [];
  dealerList: DealerList;
  ng: Dealer = new Dealer();
  edit: boolean;
  dealerFilter: DealerFilter;
  dealerLinkToProductEnabled = false;
  displayElement = false;
  dealerNameListForYUC = new Set<string>();

  constructor(private service: DealerService, private http: HttpService, private featureToggleService: FeatureToggleService,
              private authService: AuthService) {
  }

  ngOnInit() {
    this.market = this.authService.market();
    this.displayElement = this.market === Market.NL;
    this.regions = this.market === Market.BE ? ['BE', 'LUX'] : ['NL'];
    this.checkIsDealerLinkToProductEnabled();
    this.dealerFilter = new DealerFilter();
    if (!this.dealerFilter.page) {
      this.dealerFilter.page = 0;
    }
    this.fetchDealerList();
    this.addYucDealersToYucList();
  }

  updateContractType(event, contactType: string, dealer: Dealer, bonusMalus: string) {
    if (event.checked) {
      this.addContractItems(dealer, contactType, this.bonus(bonusMalus));
    } else {
      const dealerProduct = dealer.products.find(item => item.product.contractType === contactType);
      dealerProduct.dealer = null;
      this.service.deleteDealerProduct(dealerProduct).subscribe(() => {
        this.fetchDealerList();
      });
    }
  }


  addContractItems(dealer: Dealer, contactType: string, bonusMalus: number): void {
    let dealerProduct: DealerProduct;

    this.contractTypes.filter(subjectContractType => {
      return subjectContractType.contractType === contactType;
    }).forEach(filteredContractType =>
      dealerProduct = {
        id: undefined,
        dealer,
        product: filteredContractType,
        bonusMalusFactor: bonusMalus ? bonusMalus : 1
      });

    this.service.addDealerProduct(dealerProduct).subscribe((deal: Dealer) => {
      this.fetchDealerList();
    });
  }

  bonus(bonusMalus: string): number {
    return isNumber(bonusMalus) ? parseFloat(bonusMalus) : 1;
  }

  updateBonusMalus(contactType: string, dealer: Dealer, bonusMalus: string) {
    const bonus: number = this.bonus(bonusMalus);
    const dealers: Array<Dealer> = this.dealerList.dataList.filter((currentDealer) => {
      return currentDealer.dealerName === dealer.dealerName;
    });

    dealers.forEach((currentDealer: Dealer) => {
      let products: Array<DealerProduct> = currentDealer.products.filter((currentProduct: DealerProduct) => {
        return currentProduct.product.contractType === contactType;
      });

      if (products.length > 0) {

        products = [products[0]];

        products.forEach((currentProduct: DealerProduct) => {
          currentProduct.bonusMalusFactor = bonus;
          currentProduct.dealer = currentDealer;
          currentProduct.dealer.products = [];

          this.service.addDealerProduct(currentProduct).subscribe(() => {
            this.fetchDealerList();
          });
        });
      }

    });
  }

  doesDealerHaveContractType(contactType: string, dealer: Dealer): boolean {
    return dealer.products && dealer.products.find(item => {
      return item.product.contractType === contactType;
    }) != null;
  }

  bonusMalusForDealerProduct(contactType: string, dealer: Dealer): number {
    const product = dealer.products && dealer.products.find(item => {
      return item.product.contractType === contactType;
    });

    return product && product.bonusMalusFactor ? product.bonusMalusFactor : undefined;
  }

  fetchContractTypes() {
    this.http.fetchActiveContractTypes().subscribe((res) => {
      this.contractTypes = res;
      this.setupDisplayContractTypes();
    });
  }

  private setupDisplayContractTypes() {
    this.displayContractTypes = [];
    for (const item of this.contractTypes) {
      if (!this.displayContractTypes.includes(item.contractType)) {
        this.displayContractTypes.push(item.contractType);
      }
    }
  }

  fetchDealerList() {
    this.dealerFilter.pageSize = 15;
    this.http.fetchDealerList(this.dealerFilter).subscribe(res => this.dealerList = res);
  }

  addDealer() {
    if (this.ng.dealerName == null || this.ng.dealerNumber == null || this.ng.dealerRegion == null ||
      this.ng.buno == null || this.ng.businessPartnerId == null) {
      alert('Please fill in all dealer fields!');
    } else {
      this.http.addDealer(this.ng).subscribe(() => {
        this.ng.dealerNumber = '';
        this.ng.dealerName = '';
        this.ng.dealerRegion = '';
        this.ng.buno = '';
        this.ng.businessPartnerId = '';
        this.fetchDealerList();
      }, error => {
        if (error.status === 422) {
          alert('Buno number already exists - cannot save dealer');
        }
      });
    }
  }

  updateDealer(dealer: Dealer) {
    this.http.saveDealer(dealer).subscribe(() => {
      SweetUtil.showSuccess('Dealer was updated').then();
      this.fetchDealerList();
    }, error => {
      if (error.status === 422) {
        alert('Buno number already exists - cannot save dealer');
      }
      SweetUtil.showWarning(error);
    });
  }

  orderBy(field: string) {
    if (this.dealerFilter.orderBy === field) {
      if (this.dealerFilter.order === 'ASC') {
        this.dealerFilter.order = 'DESC';
      } else {
        this.dealerFilter.order = 'ASC';
      }
    }
    this.dealerFilter.orderBy = field;
    this.fetchDealerList();
  }

  showDirectionImage(): string {
    if (this.dealerFilter.order === 'ASC') {
      return 'assets/images/icon-sort-up.png';
    } else {
      return 'assets/images/icon-sort-down.png';
    }
  }

  changePage(count: number) {
    this.dealerFilter.page += count;
    this.fetchDealerList();
    if (this.dealerFilter.page > 0) {
      (<HTMLInputElement>document.getElementById('removePage')).removeAttribute('disabled');
    }
  }

  search() {
    this.fetchDealerList();
  }

  clear() {
    this.dealerFilter.dealerName = null;
    this.dealerFilter.dealerNumber = null;
    this.dealerFilter.orderBy = null;
    this.fetchDealerList();
  }

  private checkIsDealerLinkToProductEnabled() {
    this.featureToggleService
      .isFeatureToggleActive(FeatureToggle.DEALER_LINK_TO_PRODUCT)
      .subscribe(result => this.setDealerLinkToProductEnabledToggle(result));
  }

  private setDealerLinkToProductEnabledToggle(result: boolean) {
    this.dealerLinkToProductEnabled = result;
    if (this.dealerLinkToProductEnabled) {
      this.fetchContractTypes();
    }
  }

  addYucDealersToYucList(){
    this.dealerNameListForYUC.add('BMW Group Belux');
  }
  isDealerInYucList(dealer: string, contractType: string) {
    if (!contractType.includes('MINI NEXT YUC')) {
      return true;
    }
    return this.dealerNameListForYUC.has(dealer) && contractType.includes('MINI NEXT YUC');
  }

}
